import React, { useState } from "react";
import { Flex, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, FormControl, FormLabel, Input, ModalFooter, Button, useDisclosure, useToast } from "@chakra-ui/react";
import { commonFetch } from '@/utils/util'

export default function WithdrawModal(props) {

  const { isOpen, onOpen, onClose } = useDisclosure()
  const finalRef = React.useRef()
  const toast = useToast();
  const [form, setForm] = useState({
    amount: "", 
    customerName: "", 
    customerTaxId: "", 
    customerAddress: "", 
    customerPhone: "", 
    bankName: "", 
    bankAccount: "" 
  })

  const confirmOpenBill = () => {
    if (!form.amount) {
      toast({
        title: "请填写开票金额",
        status: "error",
      })
      return
    }

    if (!+form.amount) {
      toast({
        title: "开票金额不能小于等于0",
        status: "error",
      })
      return
    }

    if (!form.customerName || !form.customerName.trim() ) {
      toast({
        title: "请填写客户名称",
        status: "error",
      })
      return
    }

    if (!form.customerTaxId || !form.customerTaxId.trim() ) {
      toast({
        title: "请填写客户税号",
        status: "error",
      })
      return
    }

    commonFetch({
      url: '/api/invoice/apply',
      method: 'post',
      data: {
        ...form
      }
    }, toast).then(res => {
      setForm({
        amount: "", 
        customerName: "", 
        customerTaxId: "", 
        customerAddress: "", 
        customerPhone: "", 
        bankName: "", 
        bankAccount: "" 
      })
      toast({
        title: "开票成功",
        status: "success",
      })
      onClose()
      props.onSuccess && props.onSuccess()
    }).catch(() => {
    })
  }

  const setValue = (val) => {
    setForm(all => ({
      ...all,
      ...val
    }))
  }
  return (
    <>
      {/* <Button 
        variant='brand'
        color='white'
        fontSize='sm'
        fontWeight='500'
        borderRadius='70px'
        mb="20px"
        width={'120px'}
        onClick={onOpen}
      >
        开票
      </Button> */}
      <Modal
        initialFocus
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>开票</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl mt={4}>
              <FormLabel>
                <Flex>
                  <Text color='red'>*</Text>
                  <Text>开票金额</Text>
                </Flex>
              </FormLabel>
              <Input type="number" value={form.amount} placeholder="请输入开票金额" onChange={e => setValue({ amount: e.target.value })} />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>
                <Flex>
                  <Text color='red'>*</Text>
                  <Text>客户名称</Text>
                </Flex>
              </FormLabel>
              <Input value={form.customerName} placeholder="填写客户名称" onChange={e => setValue({ customerName: e.target.value })} />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>
                <Flex>
                  <Text color='red'>*</Text>
                  <Text>客户税号</Text>
                </Flex>
              </FormLabel>
              <Input value={form.customerTaxId} placeholder="填写客户税号" onChange={e => setValue({ customerTaxId: e.target.value })}  />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>单位地址</FormLabel>
              <Input value={form.customerAddress} placeholder="填写客户税号" onChange={e => setValue({ customerAddress: e.target.value })} />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>电话</FormLabel>
              <Input value={form.customerPhone} placeholder="填写填写电话" onChange={e => setValue({ customerPhone: e.target.value })} />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>开户银行名称</FormLabel>
              <Input value={form.bankName} placeholder="请填写开户银行名称" onChange={e => setValue({ bankName: e.target.value })} />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>银行账户</FormLabel>
              <Input value={form.bankAccount} placeholder="请填写银行账户" onChange={e => setValue({ bankAccount: e.target.value })} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="brand" variant='darkBrand' mr={3} onClick={confirmOpenBill}>
              确认
            </Button>
            <Button onClick={onClose}>取消</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}